import React from 'react';
import PropTypes from 'prop-types';
import { CommentCount } from 'disqus-react';

import Badges from 'components/badges';
import { CalendarIcon, CommentIcon } from 'components/icons';

import {
  getCategoryNames,
  getAuthorDetails,
  getDisqusConfig,
} from './Update.helpers';
import {
  updateMeta,
  metaItem,
  itemValue,
  authorContainer,
} from './scss/UpdateMeta.module.scss';

const UpdateMeta = ({ post }) => {
  const categories = getCategoryNames(post.categories);
  const author = getAuthorDetails(post);
  return (
    <div className={updateMeta}>
      <div className={authorContainer}>
        <img src={author.avatar} alt={author.name} />
        <span>{author.name}</span>
      </div>
      <div>
        <span className={metaItem}>
          <Badges items={categories} />
        </span>
        <span className={metaItem}>
          <CalendarIcon /> <span className={itemValue}>{post.date}</span>
        </span>
        <span className={metaItem}>
          <CommentIcon />
          <span className={itemValue}>
            <CommentCount {...getDisqusConfig(post)} />
          </span>
        </span>
      </div>
    </div>
  );
};

UpdateMeta.propTypes = {
  post: PropTypes.shape({}).isRequired,
};

export default UpdateMeta;
